<template>
    <div class="main_data_div">
        <div class="col-md-12  p-left-0 p-right-0 ">

            <div class="col-md-6 col-xs-6 p-left-0 ">
                <p class="location_icon_section_title p-bottom-8 " >
                     Online / Virtual
                </p>
            </div>
            <div class="col-md-6 col-xs-6 p-right-0">
                <a   href="#"   class=" float-right " data-toggle="modal" data-target="#openLocationComponentAsPopup" @click="emitEventBus()" >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3768_41969)">
                            <path d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z" fill="#2E4051"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_3768_41969">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
            </div>
        </div>

        <div class="row" >
            <div class="col-md-12"  >
                <div   class="p-bottom-10 p-left-0 location-container-with-alpha mb-12 col-xs-12" style="display: flex;">
                    <span   class="p-right-20 p-top-13">
                         <i   aria-hidden="true" class="glyphicon glyphicon-check" style="color: rgb(133, 133, 133);"></i>
                    </span>
                            <span >
                                <b data-v-1d491861="" class="marker_label_title">  Meeting link  </b>
                                <br >
                                <a   :href="`${bookingObject.online_virtual_meeting_link}`" target="_blank" style="text-decoration: none;">
                                    <span data-v-1d491861="">  {{  Data_online_virtual_meeting_link }}  </span>
                                </a>
                            </span>
                </div>

            </div>
        </div>
    </div>


</template>

<script>


import {EventBus} from "@/events/event-bus";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";

export default {
    name: "onlineVirtualBooking",
    components: {ConfirmationPopup},
    props: {
        isVirtual: null,
        bookingObject: null,
    },
    data() {
        return {
            isVirtual:this.isVirtual,
            Data_online_virtual_meeting_link: this.bookingObject.online_virtual_meeting_link,
        }
    },

      mounted() {
        EventBus.$on('bookingVirtual', (data_bookingVirtual) => {
          this.Data_online_virtual_meeting_link= data_bookingVirtual ;
        })
    },
    methods: {
      emitEventBus(){
        EventBus.$emit('onLoadOtherComponent')
      }

    },
    watch: {

    }
}


</script>

<style scoped>

.marker_label_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H5 */
    font-family: Roboto;
     font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
}

.marker_label_link{
    color: var(--Navy, #2E4051);
    /* Title/Left/H5 */
    font-family: Roboto;
     font-style: normal;
    line-height: 24px;
    text-decoration: none;
}

.location_icon_section_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H4 */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
}


</style>